import { ButtonOutlinePrimary, Icon, useCopyToClipboard } from '@lambdacurry/component-library';
import { Dispatch, FC, SetStateAction, useEffect } from 'react';

// Note: copying within a drawer is complicated and required a container to be set.

const CopyReferralCodeInviteButtonContent = ({ referralCode = 'asdf', clipboardContainer }) => {
  const [copyText, copyState] = useCopyToClipboard(
    `${process.env.GATSBY_STOREFRONT_URL}/referral/${referralCode}`,
    '.copy-referral-invite',
    {
      copyable: 'Copy Invite Link',
      error: 'Error copying, try again',
      options: {
        container: clipboardContainer
      }
    }
  );

  return (
    <ButtonOutlinePrimary
      className="copy-referral-invite flex-1"
      icon={<Icon name="copy" />}
      disabled={copyState === 'copied'}
    >
      {copyText}
    </ButtonOutlinePrimary>
  );
};

export const CopyReferralCodeInviteButton: FC<{
  referralCode?: string;
  setClipboardContainer: Dispatch<SetStateAction<Element>>;
  clipboardContainer: Element | null;
}> = ({ setClipboardContainer, ...props }) => {
  useEffect(() => {
    setClipboardContainer(window.document.querySelector('.side-nav .lc-drawer-content'));
  }, []);

  return props.clipboardContainer && <CopyReferralCodeInviteButtonContent {...props} />;
};
